/*eslint-disable */

import 'vue-datetime/dist/vue-datetime.css'

import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import { VueEditor } from "vue2-editor";
import { bus } from '@/main';
import {mapGetters} from 'vuex';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery'); 
// You need a specific loader for CSS files
Vue.component('multiselect', Multiselect)
export default {
  name: 'update-research-group-detail',
  components: {
    VueEditor
  },
  props: ['updateResearchGroupPopupID'],
  data () {
    return {
      submitted:false,
      comment:'',
      name:'',
      allUserList:null,
      allUserListResults:[],
      options:[],
      users:[],
      sentUserData:[],
      paperPileDetails:null,
      paperPileResults:[],
      paperPileOptions:[],
      paperPileValue:[],
      sentPaperIds:[],
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold', 'italic', 'link', '|', 'heading', 'fontFamily', 'fontSize', 'undo', 'redo']
      },
      editorData:''
    }
  },
  computed: {
    ...mapGetters([
      'isConditionalListOfAllUsersGetters',
      'getPaperPileListGetters'
    ]),
    getAllUserList() {
      this.allUserList = this.$store.getters.isConditionalListOfAllUsersGetters.data;
      return;
    },
    setIntialsState(){
      if(this.allUserList){
        this.allUserListResults = this.allUserList
        for(var i = 0; i < this.allUserListResults.length; i++){
          this.options.push({first_name:this.allUserListResults[i].first_name,last_name:this.allUserListResults[i].last_name,email:this.allUserListResults[i].email, id : this.allUserListResults[i].id})
        }
      }
    },
    getPaperListInfo(){
      this.paperPileDetails = this.$store.getters.getPaperPileListGetters.data
      return
    },
    setIntialPaperState(){
      if(this.paperPileDetails){
        this.paperPileResults = this.paperPileDetails.results
        for(var i = 0; i < this.paperPileResults.length; i++){
          this.paperPileOptions.push({title:this.paperPileResults[i].title, id : this.paperPileResults[i].id})
        }
      }
    }
  },
  mounted () {
    this.getAllUserList
    this.setIntialsState
    this.getPaperListInfo
    this.setIntialPaperState
    this.$store.dispatch('getResearchGroupDetailsByIDFun', {id:this.updateResearchGroupPopupID}).then((res)=>{
      this.name =  res.data.data.name
      this.comment =  res.data.data.topic
      for(var i = 0; i < res.data.data.users.length; i++){
        this.users.push({first_name:res.data.data.users[i].user.first_name,last_name:res.data.data.users[i].user.last_name,email:res.data.data.users[i].user.email, id : res.data.data.users[i].user.id})
      }
      for(var i = 0; i < res.data.data.pdf_papers.length; i++){
        this.paperPileValue.push({title:res.data.data.pdf_papers[i].pdf_paper.title, id : res.data.data.pdf_papers[i].pdf_paper.id})
      }
    })
  },
  methods: {
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    getResearchGroupListAgain(){
      this.$store.dispatch('getResearchGroupListFun')
    },
    updateResearchGroupBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          for(var i = 0; i < this.users.length; i++){
            this.sentUserData.push(this.users[i].id)
          }
          for(var i = 0; i < this.paperPileValue.length; i++){
            this.sentPaperIds.push(this.paperPileValue[i].id)
          }
          let data = {
            name:this.name,
            topic:this.comment,
            users:this.sentUserData,
            pdf_paper:this.sentPaperIds
          }
          this.$store.dispatch('updateResearchGroupDetailsByIDFun',{data:{data:data,id:this.updateResearchGroupPopupID}})
            .then((res) => {  
              this.$validator.reset()
              toast.success(res.data.msg);
              this.getResearchGroupListAgain()
              this.closeUpdateRGroupPopup()
              this.submitted =  false
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    closeUpdateRGroupPopup(){
      bus.$emit('updateResearchGroupPopupStateBus', false);
      $('body').removeClass('body_right_scroll_remove')
    }
  },
  watch:{
    getAllUserList() {
      return this.$store.getters.isConditionalListOfAllUsersGetters
    },
    setIntialsState(){
      if(this.allUserList){
        this.allUserListResults = this.allUserList
        for(var i = 0; i < this.allUserListResults.length; i++){
          this.options.push({first_name:this.allUserListResults[i].first_name,last_name:this.allUserListResults[i].last_name,email:this.allUserListResults[i].email, id : this.allUserListResults[i].id})
        }
      }
    },
    getPaperListInfo(){
      this.paperPileDetails = this.$store.getters.getPaperPileListGetters.data
      return
    },
    setIntialPaperState(){
      if(this.paperPileDetails){
        this.paperPileResults = this.paperPileDetails.results
        for(var i = 0; i < this.paperPileResults.length; i++){
          this.paperPileOptions.push({title:this.paperPileResults[i].title, id : this.paperPileResults[i].id})
        }
      }
    }
  }
}